<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Detail Points"
    :show-banner="false"
    :show-sponsors="false"
    :show-back-button="true"
    :hide-sidebar="true"
    @back="goBack"
  >

    <!-- Main Content -->
    <div class="content-section">
      <div class="content-container">
        <!-- User Profile Section -->
        <div class="user-profile-section">
          <div class="user-info">
            <div class="user-avatar">
              <img 
                :src="detailUser.image || require('@/assets/maternity.png')" 
                :alt="detailUser.name" 
                class="avatar-image"
              />
            </div>
            <div class="user-details">
              <h3 class="user-name">{{ detailUser.name || 'User Name' }}</h3>
              <p class="user-community">{{ detailUser.community?.community || 'Member Community' }}</p>
            </div>
          </div>
          
          <div class="points-summary">
            <div class="points-icon">
              <img src="@/assets/berts-point-reward.svg" alt="Points" class="points-svg" />
            </div>
            <div class="points-info">
              <p class="points-label">Total Points</p>
              <p class="points-value">{{ totalPoints }}</p>
            </div>
          </div>
        </div>

        <!-- Points History Section -->
        <div class="points-history-section">
          <div class="section-header">
            <h2 class="section-title">Riwayat Points</h2>
            <div class="pagination-info">
              <span class="show-text">Show</span>
              <select v-model="perPage" @change="loadEventForm" class="per-page-select">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span class="per-page-text">/ Page</span>
            </div>
          </div>

          <!-- Points List -->
          <div v-if="!forms || forms.length === 0" class="empty-state">
            <div class="empty-icon">
              <i class="mdi mdi-history"></i>
            </div>
            <h3 class="empty-title">Belum Ada Riwayat</h3>
            <p class="empty-description">Riwayat points akan muncul di sini setelah Anda mengikuti event.</p>
          </div>

          <div v-else class="points-list">
            <div 
              v-for="(form) in forms" 
              :key="form.id" 
              class="point-item"
            >
              <div class="point-content">
                <div class="point-info">
                  <h4 class="point-title">{{ form.event?.name || 'Event Name' }}</h4>
                  <p class="point-date">{{ formatDate(form.date) }}</p>
                  <span style="color:darkgrey">Expiry On </span><span>{{ getExpiryDate(form.date)
                                            }}</span>
                </div>
                
                <div class="point-status">
                  <span 
                    class="status-badge" 
                    :class="getStatusClass(form.status)"
                  >
                    {{ getStatusText(form.status) }}
                  </span>
                </div>
              </div>
              
              <div v-if="form.status !== 'invalid'" class="point-value">
                <span class="point-amount" :class="getPointClass(form.status)">
                  +{{ form.point }}
                </span>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div v-if="pagination && pagination.last_page > 1" class="pagination-section">
            <div class="pagination-controls">
              <button 
                class="pagination-btn" 
                :disabled="pagination.current_page === 1"
                @click="changePage(1)"
              >
                1
              </button>
              
              <button 
                v-if="pagination.current_page > 3"
                class="pagination-btn dots"
                disabled
              >
                ...
              </button>
              
              <button 
                v-for="page in visiblePages" 
                :key="page"
                class="pagination-btn" 
                :class="{ 'active': page === pagination.current_page }"
                @click="changePage(page)"
              >
                {{ page }}
              </button>
              
              <button 
                v-if="pagination.current_page < pagination.last_page - 2"
                class="pagination-btn dots"
                disabled
              >
                ...
              </button>
              
              <button 
                v-if="pagination.last_page > 1"
                class="pagination-btn" 
                :disabled="pagination.current_page === pagination.last_page"
                @click="changePage(pagination.last_page)"
              >
                {{ pagination.last_page }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';

export default {
  name: "NewReward",
  components: {
    PageLayout: AppPageLayout
  },
  data() {
    return {
      isLoading: false,
      detailUser: {},
      forms: [],
      pagination: null,
      perPage: 10,
      currentPage: 1,
      errors: []
    };
  },
  computed: {
    totalPoints() {
      console.log("CHECK WITH", this.forms[0].user?.point, "-", this.detailUser.point)
      if (this.forms && this.forms.length > 0) {
        console.log("HERER")
        return this.forms[0].user?.point || this.detailUser.point || 0;
      }
      console.log("NO BRO HERER")
      return this.detailUser.point || 0;
    },
    
    visiblePages() {
      if (!this.pagination) return [];
      
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;
      const pages = [];
      
      // Show pages around current page
      for (let i = Math.max(2, current - 1); i <= Math.min(last - 1, current + 1); i++) {
        if (i !== 1 && i !== last) {
          pages.push(i);
        }
      }
      
      return pages;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    loadEventForm() {
      const baseURI = this.$settings.endPoint + "event-form/select";
      const params = new URLSearchParams({
        page: this.currentPage,
        limit: this.perPage
      });
      
      this.isLoading = true;
      
      this.$http
        .get(`${baseURI}?${params}`, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.datas) {
            if (Array.isArray(response.data.datas)) {
              this.forms = response.data.datas;
              this.pagination = null;
            } else {
              // Paginated response
              this.forms = response.data.datas.data || [];
              this.pagination = {
                current_page: response.data.datas.current_page,
                last_page: response.data.datas.last_page,
                per_page: response.data.datas.per_page,
                total: response.data.datas.total
              };
            }
          } else {
            this.forms = [];
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    changePage(page) {
      if (page !== this.currentPage && page >= 1 && page <= this.pagination.last_page) {
        this.currentPage = page;
        this.loadEventForm();
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const options = { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      
      return date.toLocaleDateString('id-ID', options);
    },

    getStatusClass(status) {
      switch (status) {
        case 'valid':
          return 'status-valid';
        case 'invalid':
          return 'status-invalid';
        case 'expired':
          return 'status-expired';
        case 'pending':
        default:
          return 'status-pending';
      }
    },

    getStatusText(status) {
      switch (status) {
        case 'valid':
          return 'Tervalidasi';
        case 'invalid':
          return 'Reject';
        case 'expired':
          return 'Expired';
        case 'pending':
        default:
          return 'Pending';
      }
    },

    getPointClass(status) {
      switch (status) {
        case 'valid':
          return 'point-valid';
        case 'expired':
          return 'point-expired';
        case 'pending':
        default:
          return 'point-pending';
      }
    },

    getExpiryDate(date) {
      if (!date) return '';

      if (this.detailUser.community_id === 12 || this.detailUser.community_id === 13) {
        const givenDate = new Date(date);
        const nextYear = givenDate.getFullYear() + 1;
        const formattedDate = new Date(nextYear, 0, 31);
        const options = { day: '2-digit', month: 'long', year: 'numeric' };
        return formattedDate.toLocaleDateString('en-GB', options);
      }

      const inputDate = new Date(date);
      const cutoffDate = new Date('2024-09-31');
      
      if (inputDate <= cutoffDate) {
        return '01 November 2024';
      }

      inputDate.setMonth(inputDate.getMonth() + 2);
      inputDate.setDate(1);
      
      const options = { day: '2-digit', month: 'long', year: 'numeric' };
      return inputDate.toLocaleDateString('id-ID', options);
    },

    fetchUserData() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub || {};
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          this.handleErrors(error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      } else if (error.code === "ECONNABORTED") {
        this.error("Please check your internet connection");
      } else {
        this.error("An error occurred. Please try again.");
      }
    },

    handleErrors(errors) {
      this.errors = errors;
      if (errors) {
        Object.keys(errors).forEach(key => {
          if (errors[key] && errors[key].length > 0) {
            this.error(errors[key][0]);
          }
        });
      }
    },

    error(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F2994A'
      });
    }
  },

  mounted() {
    this.fetchUserData();
    this.loadEventForm();
  }
};
</script>

<style scoped>
/* ========================================= */
/* HEADER SECTION                            */
/* ========================================= */
.reward-detail-header {
  background: linear-gradient(135deg, #F2994A 0%, #F2C94C 100%);
  padding: 32px;
  margin: 0 auto 32px auto;
  border-radius: 16px;
  max-width: 1200px;
  width: calc(100% - 64px);
  position: relative;
  overflow: hidden;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.header-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-logo {
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.logo-icon {
  width: 32px;
  height: 32px;
}

/* ========================================= */
/* CONTENT SECTION                           */
/* ========================================= */
.content-section {
  padding: 0 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.content-container {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* ========================================= */
/* USER PROFILE SECTION                      */
/* ========================================= */
.user-profile-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 32px;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 32px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #F2994A;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 4px 0;
}

.user-community {
  font-size: 0.9rem;
  color: #6B7280;
  margin: 0;
}

.points-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #FEF3E2;
  padding: 16px 20px;
  border-radius: 12px;
  border: 2px solid #F2994A;
}

.points-icon {
  width: 40px;
  height: 40px;
  background: #F2994A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.points-svg {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.points-info {
  display: flex;
  flex-direction: column;
}

.points-label {
  font-size: 0.85rem;
  color: #92400E;
  margin: 0 0 2px 0;
  font-weight: 500;
}

.points-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #92400E;
  margin: 0;
}

/* ========================================= */
/* POINTS HISTORY SECTION                    */
/* ========================================= */
.points-history-section {
  width: 100%;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #6B7280;
}

.per-page-select {
  padding: 4px 8px;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
}

.show-text,
.per-page-text {
  font-size: 0.9rem;
  color: #6B7280;
}

/* ========================================= */
/* EMPTY STATE                               */
/* ========================================= */
.empty-state {
  text-align: center;
  padding: 48px 24px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  background: #F3F4F6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  font-size: 2.5rem;
  color: #9CA3AF;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.empty-description {
  color: #6B7280;
  margin: 0;
  line-height: 1.6;
}

/* ========================================= */
/* POINTS LIST                               */
/* ========================================= */
.points-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.point-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.point-item:hover {
  border-color: #F2994A;
  box-shadow: 0 4px 12px rgba(242, 153, 74, 0.1);
}

.point-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin-right: 16px;
}

.point-info {
  display: flex;
  flex-direction: column;
}

.point-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 4px 0;
}

.point-date {
  font-size: 0.85rem;
  color: #F2994A;
  margin: 0;
}

.point-status {
  display: flex;
  align-items: center;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge.status-valid {
  background: #D1FAE5;
  color: #065F46;
}

.status-badge.status-pending {
  background: #E0E7FF;
  color: #3730A3;
}

.status-badge.status-invalid {
  background: #FEE2E2;
  color: #991B1B;
}

.status-badge.status-expired {
  background: #FEF3C7;
  color: #92400E;
}

.point-value {
  display: flex;
  align-items: center;
}

.point-amount {
  font-size: 1.1rem;
  font-weight: 700;
}

.point-amount.point-valid {
  color: #059669;
}

.point-amount.point-pending {
  color: #4F46E5;
}

.point-amount.point-expired {
  color: #D97706;
}

/* ========================================= */
/* PAGINATION                                */
/* ========================================= */
.pagination-section {
  margin-top: 32px;
  display: flex;
  justify-content: center;
}

.pagination-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pagination-btn {
  padding: 8px 12px;
  border: 1px solid #D1D5DB;
  background: white;
  color: #374151;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  min-width: 40px;
  text-align: center;
}

.pagination-btn:hover:not(:disabled) {
  border-color: #F2994A;
  color: #F2994A;
}

.pagination-btn.active {
  background: #F2994A;
  color: white;
  border-color: #F2994A;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn.dots {
  border: none;
  background: transparent;
  cursor: default;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .reward-detail-header,
  .content-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 20px;
  }
  
  .content-container {
    padding: 24px 20px;
  }
  
  .header-content {
    gap: 16px;
  }
  
  .header-title {
    font-size: 1.4rem;
  }
  
  .header-icon,
  .header-logo {
    width: 40px;
    height: 40px;
  }
  
  .logo-icon {
    width: 24px;
    height: 24px;
  }
  
  .user-profile-section {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }
  
  .points-summary {
    align-self: stretch;
    justify-content: center;
  }
  
  .section-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .point-item {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .point-content {
    width: 100%;
    margin-right: 0;
  }
  
  .point-value {
    align-self: flex-end;
  }
  
  .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>